<af-main-container [title]="title"
                   [showBreadcrumbs]="true"
                   spinnerIds="initial"
                   [buttonDisabled]="isExporting"
                   [tabPathToTab]="tabPathToTab"
                   [specialFilter]="specialFilter"
                   [breadcrumbCustomizer]="breadcrumbCustomizer"
                   (buttonClickListener)="downloadExport()"
                   [buttonLabel]="activeTab !== 'commonInformationTab' ? ('i18n_af_buttonDownloadReport' | translate) : null">
    @if (activeTab === 'commonInformationTab' && authHolderService.hasAccess(['npck-admin'])) {
        <div CustomButtons fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="16px">
            <ui-kit-svg class="i-24 pointer c-primary-green-800 mr-16" name="ic_edit" (click)="editClassification()"/>
        </div>
    }
    <div class="w-100 h-100"
         fxLayout="column" fxLayoutAlign="start start" fxLayoutGap="16px">
        <mat-tab-group mat-align-tabs="start" animationDuration="0"
                       class="w-100 h-100 overflow-y-scroll"
                       [(selectedIndex)]="selectedTabIndex"
                       (selectedIndexChange)="handleNavigation($event)">
            @for (tab of tabs; track tab) {
                <mat-tab [label]="'i18n_af_' + tab | translate" class="text-center h-100">
                    <ng-template matTabContent>
                        <div fxLayout="column" fxLayoutAlign="stretch stretch" fxLayoutGap="24px" class="w-100 pt-24">
                            <af-warning-panel warningText="i18n_af_warningPanelClassification"
                                              (clickListener)="downloadDocument()"/>
                            @if (tab === 'commonInformationTab') {
                                <af-classification-common-information-tab [subtype]="subtype" (clickListener)="editClassification()"/>
                            } @else if (tab === 'transactionInformationTab') {
                                <af-classification-table
                                    [context]="transactionInformationTabTableContext"
                                    [type]="type"
                                    [subtype]="subtype"
                                    class="h-fit-content w-100" fxFlex/>
                            } @else if (tab === 'participantInformationTab') {
                                <div fxLayout="column" fxLayoutAlign="start start" class="w-100 h-100 h-fit-content" fxLayoutGap="60px"
                                     fxFlex>
                                    <af-classification-table
                                        [participantRole]="ParticipantRole.VICTIM"
                                        [type]="type"
                                        [subtype]="subtype"
                                        context="subject_victim"
                                        sectionTitle="i18n_af_category#VICTIM"
                                        class="w-100"
                                        fxFlex
                                        />
                                    <af-classification-table
                                        [participantRole]="ParticipantRole.SUSPECT"
                                        [type]="type"
                                        [subtype]="subtype"
                                        context="subject_suspect"
                                        sectionTitle="i18n_af_labelSuspect"
                                        class="w-100"
                                        fxFlex/>
                                </div>
                            }

                        </div>
                    </ng-template>
                </mat-tab>
            }
        </mat-tab-group>
    </div>
</af-main-container>
